import React from 'react'
import { View } from 'react-native'

export function CardGrid({ children, minWidth, style }: { children: React.ReactNode; minWidth: number; style?: any }) {
  return (
    <View style={[{ flexDirection: 'row', flexWrap: 'wrap', gap: 24 }, style]}>
      {React.Children.map(children, child => (
        <View style={{ flex: 1, minWidth }}>{child}</View>
      ))}
    </View>
  )
}
